import { fromJS } from 'immutable';
import createAction from '../../../../utils/redux-helpers/createAction';

const handler = (state, { data }) =>
  state.setIn(['tables', 'deliveryZones'], fromJS(data));

export const setDeliveryZones = createAction({
  action: ['setDeliveryZones', 'data'],
  handler,
});
